import { useSession } from '../../hooks/useSession';
import { FAQ } from './sections/FAQ';
import { FinalCTA } from './sections/FinalCTA';
import { Footer } from './sections/Footer';
import { ForAgents } from './sections/ForAgents';
import { Hero } from './sections/Hero';
import { ProductTour } from './sections/ProductTour';
import { WhySendFast } from './sections/WhySendFast';
import { Nav } from './sections/Nav';
import { Pricing } from './sections/Pricing';
import { SocialProof } from './sections/SocialProof';
// Hidden temporarily — uncomment alongside the <TryItLive /> below to re-enable.
// import { TryItLive } from './sections/TryItLive';

/**
 * Public landing page (spec §7.3.1).
 *
 * Pulls together every section. Each one reveals on scroll and the live demo
 * widget sits inside <Hero />, so signed-out visitors can generate one full
 * email before being asked to sign up.
 *
 * Auth-aware:
 * - Nav and Hero / FinalCTA CTAs swap to "Open dashboard →" for signed-in users
 * - Pricing's Free CTA still routes to /sign-up; the dashboard reuses
 *   PricingCards directly via Settings → Usage
 */
export function LandingPage() {
  const { user } = useSession();

  return (
    <div className="min-h-screen bg-bg text-ink">
      <Nav user={user} />
      <main>
        <Hero user={user} />
        {/* <TryItLive /> hidden until we're ready — bring back here + uncomment its import above. */}
        <SocialProof />
        <ProductTour />
        <WhySendFast />
        <ForAgents />
        <Pricing />
        <FAQ />
        <FinalCTA user={user} />
      </main>
      <Footer />
    </div>
  );
}
